"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@comunica/core");
/**
 * A mediator that can mediate over a single number field.
 *
 * It takes the required 'field' and 'type' parameters.
 * The 'field' parameter represents the field name of the test result field over which must be mediated.
 * The 'type' parameter
 */
class MediatorNumber extends core_1.Mediator {
    constructor(args) {
        super(args);
        this.indexPicker = this.createIndexPicker();
    }
    /**
     * @return {(tests: T[]) => number} A function that returns the index of the test result
     *                                  that has been chosen by this mediator.
     */
    createIndexPicker() {
        switch (this.type) {
            case MediatorNumber.MIN:
                return (tests) => tests.reduce((a, b, i) => {
                    const val = this.getOrDefault(b[this.field], Infinity);
                    return val !== null && (isNaN(a[0]) || a[0] > val) ? [val, i] : a;
                }, [NaN, -1])[1];
            case MediatorNumber.MAX:
                return (tests) => tests.reduce((a, b, i) => {
                    const val = this.getOrDefault(b[this.field], -Infinity);
                    return val !== null && (isNaN(a[0]) || a[0] < val) ? [val, i] : a;
                }, [NaN, -1])[1];
        }
        throw new Error('No valid "type" value was given, must be either '
            + MediatorNumber.MIN + ' or ' + MediatorNumber.MAX + ', but got: ' + this.type);
    }
    getOrDefault(value, defaultValue) {
        return value === undefined ? defaultValue : value;
    }
    async mediateWith(action, testResults) {
        let promises = testResults.map(({ reply }) => reply);
        const errors = [];
        if (this.ignoreErrors) {
            const dummy = {};
            dummy[this.field] = null;
            promises = promises.map((p) => p.catch((error) => {
                errors.push(error);
                return dummy;
            }));
        }
        const results = await Promise.all(promises);
        const index = this.indexPicker(results);
        if (index < 0) {
            throw new Error('All actors rejected their test in ' + this.name + '\n'
                + errors.map((e) => e.toString()).join('\n'));
        }
        return testResults[index].actor;
    }
}
MediatorNumber.MIN = "https://linkedsoftwaredependencies.org/bundles/npm/@comunica/mediator-number/" +
    "Mediator/Number/type/TypeMin";
MediatorNumber.MAX = "https://linkedsoftwaredependencies.org/bundles/npm/@comunica/mediator-number/" +
    "Mediator/Number/type/TypeMax";
exports.MediatorNumber = MediatorNumber;
//# sourceMappingURL=MediatorNumber.js.map